import { Component, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import SignaturePad from 'signature_pad';
import { MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
@Component({
  selector: 'app-signature-dialog',
  imports: [MatDialogModule, MatIcon, MatDividerModule],
  templateUrl: './signature-dialog.component.html',
  styleUrl: './signature-dialog.component.scss'
})
export class SignatureDialogComponent implements AfterViewInit {
   @ViewChild('canvas') canvas!: ElementRef;
  signaturePad!: SignaturePad;

  constructor(private dialogRef: MatDialogRef<SignatureDialogComponent>) {}

  ngAfterViewInit() {
    this.signaturePad = new SignaturePad(this.canvas.nativeElement);
  }

  clearSignature() {
    this.signaturePad.clear();
  }

  saveSignature() {
    if (!this.signaturePad.isEmpty()) {
      const base64 = this.signaturePad.toDataURL();
      this.dialogRef.close(base64);
    }
  }

}
